import api from '@/api/index'

const base = '/v2/users/favorites'

const favoritesApi = {
  async get () {
    const response = await api.asyncRequest(base, 'get')
    return response.data || null
  },
  async create ({ identifier, identifierId }) {
    const response = await api.asyncRequest(base, 'post', {
      identifier,
      identifierId
    })
    return response.data || null
  },
  async remove ({ identifier, identifierId }) {
    const response = await api.asyncRequest(base, 'delete', {
      identifier,
      identifierId
    })
    return response.data || null
  },
  async update ({ favoriteId, payload }) {
    const response = await api.asyncRequest(base + '/' + favoriteId, 'patch', payload)
    return response.data || null
  }
}

export default favoritesApi
